<template lang="pug">
  .product-accordions(
    v-if="displayAccordion"
  )
    accordion-group(v-if="benefitsAvailable || routineAvailable || ingredientsAvailable")
      accordion(v-if="benefitsAvailable" :heading="benefitsHeading")
        strong(v-html="this.product.customFields.benefits_subheading")
        div(v-html="this.product.customFields.product_benefits_content")
      accordion(v-if="routineAvailable" :heading="routineHeading")
        strong(v-html="this.product.customFields.how_to_use_subheading")
        div(v-html="this.product.customFields.how_to_use_content")
        div(v-html="this.product.customFields.how_to_use_info")
        div(v-html="this.product.customFields.how_to_use_details")
      accordion(v-if="ingredientsAvailable" :heading="ingredientHeading")
        strong(v-html="this.product.customFields.ingredients_subheading")
        div(v-html="this.product.customFields.ingredients_accordion_content[0]")
    .product-accordions__disclaimer(
      v-if="this.product.customFields.benefits_disclaimer"
      v-html="this.product.customFields.benefits_disclaimer"
    )

</template>

<script>
  import Accordion from 'scripts/components/basic/Accordion.vue';
  import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';

  export default {
    name: 'ProductAccordians',
    components: { Accordion, AccordionGroup },
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    computed: {
      displayAccordion() {
        return this.product && (this.benefitsAvailable || this.routineAvailable || this.ingredientsAvailable);
      },
      benefitsAvailable() {
        return this.product.customFields.benefits_subheading || this.product.customFields.product_benefits_content;
      },
      benefitsHeading() {
        return 'Support For';
      },
      routineAvailable() {
        return this.product.customFields.how_to_use_subheading || this.product.customFields.how_to_use_content || this.product.customFields.how_to_use_info || this.product.customFields.how_to_use_details;
      },
      routineHeading() {
        return 'Recommended Routine';
      },
      ingredientsAvailable() {
        return this.product.customFields.ingredients_subheading || (this.product.customFields.ingredients_accordion_content && this.product.customFields.ingredients_accordion_content[0]);
      },
      ingredientHeading() {
        return 'Ingredients';
      },
    },
  };
</script>

<style lang="scss" scoped>
  /*
   * 1. Matches left padding of product image carousel.
   */

  .product-accordions {
    display: block;
    padding-top: 15px;

    @include tablet-up {
      padding-top: 40px;
      padding-left: 80px; /* [1] */
    }
  }

  .product-accordions__disclaimer {
    margin-top: $spacing-unit * 2;
    padding: ($spacing-unit * 4) ($spacing-unit * 3);
    color: $color-green-900;
    font-size: rem(14);
    line-height: rem(18);
    text-align: center;
    border: 1px solid $color-green-900;

    @include tablet-up {
      padding: ($spacing-unit * 4) ($spacing-unit * 6);
    }
  }
</style>
